import { ShareEpisodeFragment } from "~/__generated__/graphql"
import { AppText } from "~/ui/app-text"
import { ChatShareMessage } from "./message/chat-share-message"
import { EpisodeCard } from "./episode-card"

interface Props {
  episode: ShareEpisodeFragment
}

export const EpisodeShareCard: React.FC<Props> = ({ episode }) => {
  const previewComments = episode.previewComments ?? []

  return (
    <div className="flex w-full max-w-[360px] flex-col gap-4">
      <EpisodeCard
        episode={episode}
        footer={
          episode.description ? (
            <AppText variant="body3-medium" className="line-clamp-3 text-neutral-300">
              {episode.description}
            </AppText>
          ) : null
        }
      />

      {previewComments.length > 0 && (
        <div className="flex flex-col gap-2">
          {previewComments.map((comment) => (
            <div key={comment.id} className="flex w-full rounded bg-neutral-100 p-4">
              <ChatShareMessage message={comment} compact />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
